import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("beg_lang") || "fr");

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("beg_lang", l);
    document.documentElement.lang = l;
  }, []);

  const t = useCallback((path) => {
    const parts = path.split(".");
    let node = translations[lang];
    for (const p of parts) {
      node = node?.[p];
      if (node === undefined) break;
    }
    if (node === undefined) {
      let fb = translations.fr;
      for (const p of parts) fb = fb?.[p];
      return fb !== undefined ? fb : path;
    }
    return node;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
